module.exports = __webpack_public_path__ + "static/fonts/Fact-Medium.87e71e6.woff";